export var INDICATOR_CLASS_PREFIX = 'Indicator';